/** Folder navigation and validation shared by both vault layouts and storage. */
import { t } from '../../shared/i18n/index.js';

export const storageOf = entry => entry?._storage || 'online';

export function folderPath(folders, id) {
  const byId = new Map(folders.map(folder => [folder.id, folder]));
  const seen = new Set(), path = [];
  let folder = byId.get(id);
  while (folder && !seen.has(folder.id)) {
    seen.add(folder.id);
    path.unshift(folder);
    folder = byId.get(folder.parentId);
  }
  return path;
}

export function folderEntries(folders) {
  const seen = new Set(), entries = [];
  const visit = (folder, depth) => {
    if (seen.has(folder.id)) return;
    seen.add(folder.id);
    entries.push({ folder, depth });
    folders.filter(child => child.parentId === folder.id)
      .sort((a, b) => a.name.localeCompare(b.name)).forEach(child => visit(child, depth + 1));
  };
  folders.filter(folder => folder.parentId === null).forEach(folder => visit(folder, 0));
  // Legacy or concurrently orphaned folders stay reachable for repair.
  folders.filter(folder => !seen.has(folder.id)).forEach(folder => visit(folder, 0));
  return entries;
}

export function destinationFolder(index, source, folderId, { movingFolder = false } = {}) {
  const storage = storageOf(source);
  const target = index.folders.find(folder => folderId ? folder.id === folderId
    : folder.parentId === null && storageOf(folder) === storage);
  if (!target) throw new Error(t('sync.folder.unavailable'));
  if (storageOf(target) !== storage) {
    throw new Error(t('sync.folder.sameVault'));
  }
  if (movingFolder && folderPath(index.folders, target.id).some(folder => folder.id === source.id)) {
    throw new Error(t('sync.folder.intoItself'));
  }
  return target;
}
